import dayjs from 'dayjs'
import { normalizeDate } from '../../../../../../libs/formatDates'

const RECOVERY_PERIOD_DAYS = 7

export const getRecoveryTime = (archivedAt?: string | number | null) => {
  if (!archivedAt) return '—'

  const deadline = dayjs(normalizeDate(archivedAt)).add(
    RECOVERY_PERIOD_DAYS,
    'day',
  )
  const now = dayjs()

  if (deadline.isBefore(now)) return 'Expired'

  const days = deadline.diff(now, 'day')
  const hours = deadline.diff(now, 'hour') % 24

  return `${days}d ${hours}h`
}
